import { Injectable } from "@angular/core";
import { API_URL } from "common/constants/sm-constants";
import { MentorModel } from "common/models/page-models/mentor/mentor-data-model";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";
import { DataService } from "../../base-data-services/data.service";

 
@Injectable()
export class IsEmailSendDataService extends DataService<MentorModel> {
    constructor(protected ss: SystemService,protected http: SmApiService) {
        super(ss,API_URL.isEmailSended,http);
    }
 

   
    createInstance(): MentorModel {
        return new MentorModel();
    }

    
 
}